<template>
  <div ref="root" class="sp-slot-picker-filter">
    <slot />
  </div>
</template>

<script setup>
import { useTemplateRef } from "vue";
import { useDefaults } from "#ce/composables/useDefaults";

const root = useTemplateRef("root");
const props = defineProps({});

useDefaults(props, root, "SpSlotPickerFilter");
</script>

<style>
:host {
  display: contents;
}
</style>
